import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    // iconfont: "mdi"
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#2D3284', // Blue
        secondary: '#1B401D', // Dark Green
        accent: '#23A1D8', // Light Blue
        error: '#DF3A55', // Pallet Triad Red
        info: '#D9AB23', // Gold
        success: '#3C8C40', // Light Green
        warning: '#F2CE16' // Yellow
      }
    }
  }
});
